import React from "react";
import CreatorsPages from "components/Marketing/Pages/Creators";
import Layout from "components/Layout";

const FeaturesPages = () => {
  return <Layout>{() => <CreatorsPages />}</Layout>;
};

export default FeaturesPages;
